/**
 * Maps course tree names to their corresponding course names in user context
 * @param {string} courseTreeName - The name of the course tree (e.g., 'highschool', 'k-5_training_tier1')
 * @returns {string} The corresponding course name
 */
export function getCourseNameFromCourseTree(courseTreeName) {
  // Course tree name to course name mapping
  const courseTreeToNameMap = {
    highschool: 'highschool',
    'k-5_training_tier1': 'k-5_training_tier1',
    '6-8_training_tier1': '6-8_training_tier1',
  }

  return courseTreeToNameMap[courseTreeName] || courseTreeName
}

/**
 * Filters user context to include only the specific course
 * @param {Object} userContext - The full user context
 * @param {string} courseName - The name of the course to filter for
 * @param {string} programKey - The program key (e.g., 'highSchool', 'k5SelDigital', 'mspDigital')
 * @returns {Object} Filtered user context containing only the specified course
 */
export function filterUserContextForCourse(
  userContext,
  courseName,
  programKey,
) {
  if (!userContext?.sites) {
    return userContext
  }

  // Create a deep clone to avoid mutating the original userContext
  const clonedUserContext = structuredClone(userContext)

  const filteredUserContext = {
    ...clonedUserContext,
    sites: clonedUserContext.sites
      .filter(site => site?.programs?.[programKey])
      .map(site => {
        const program = site.programs[programKey]
        const targetCourse = program.courses?.find(
          course => course?.name === courseName,
        )

        if (!targetCourse) {
          return null
        }

        return {
          ...site,
          programs: {
            ...site.programs,
            [programKey]: {
              ...program,
              courses: [targetCourse],
            },
          },
        }
      })
      .filter(Boolean), // Remove null sites
  }

  return filteredUserContext
}
